import { Row, Col, Card, Statistic, Skeleton, Space, Typography } from "antd";
import {
  FileTextOutlined,
  FolderOutlined,
  BookOutlined,
  RiseOutlined,
} from "@ant-design/icons";
import { COLORS } from "../../../utils/constant";

const { Text } = Typography;

const MetricCard = ({ title, value, loading, icon, color, suffix }) => {
  return (
    <Card bordered={false} style={{ height: "100%" }}>
      {loading ? (
        <Skeleton active paragraph={{ rows: 1 }} />
      ) : (
        <Space direction="vertical" size="small" style={{ width: "100%" }}>
          <Space>
            <div
              style={{
                fontSize: 24,
                color: color || COLORS[0],
                display: "flex",
                alignItems: "center",
              }}
            >
              {icon}
            </div>
            <Text type="secondary">{title}</Text>
          </Space>

          <Statistic
            value={value}
            suffix={suffix}
            valueStyle={{ fontSize: 28, fontWeight: 600 }}
          />
        </Space>
      )}
    </Card>
  );
};

const CpdSummaryPanel = ({ summary, loading, dateRange }) => {
  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Text type="secondary">
        Period: {dateRange?.[0]?.format("DD MMM YYYY")} - {dateRange?.[1]?.format("DD MMM YYYY")}
      </Text>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={8}>
          <MetricCard
            title="Completed In Depth Learning"
            value={Math.round(summary?.totalCompletedQuizzes || 0)}
            loading={loading}
            icon={<FileTextOutlined />}
            color={COLORS[3]}
          />
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <MetricCard
            title="Completed Cases"
            value={Math.round(summary?.totalCompletedCases || 0)}
            loading={loading}
            icon={<FolderOutlined />}
            color={COLORS[4]}
          />
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <MetricCard
            title="Completed Guidelines"
            value={Math.round(summary?.totalCompletedGuidelines || 0)}
            loading={loading}
            icon={<BookOutlined />}
            color={COLORS[5]}
          />
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <MetricCard
            title="Avg Completion Rate"
            value={Math.round(summary?.averageCompletionRate || 0)}
            loading={loading}
            icon={<RiseOutlined />}
            color={COLORS[2]}
            suffix="%"
          />
        </Col>
      </Row>
    </Space>
  );
};

export default CpdSummaryPanel;
